import React from 'react'
import classNames from 'classnames'
import ExpertChatButton from '#src/components/ExpertChatButton'
import { Button, Image } from '@deal/components'
import { ProductRecommendedExpertFragment } from '#src/generated/graphql'
import PageContent from '#src/components/PageContent'
import Diamond from './diamond.png'
import Experts from './experts.svg'
import Free from './free.svg'
import Price from './price.svg'
import Risk from './risk.svg'
import Shape from './shape.svg'
import styles from './styles.css'

interface JewelryAssistanceProps {
  className?: string
  sellableRecommendedExpert?: ProductRecommendedExpertFragment
}

const JewelryAssistance: React.SFC<JewelryAssistanceProps> = ({
  className,
  sellableRecommendedExpert
}) => (
  <div className={classNames(styles.section, className)}>
    <PageContent>
      <div className={styles.container}>
        <div className={styles.textContainer}>
          <div className={styles.title}>Ready for some insider secrets?</div>
          <div className={styles.listContainer}>
            <div className={styles.listItem}>
              <Risk className={styles.listImage} />
              <div className={styles.listText}>
                Buying a diamond is something most people rarely do – which means people often
                overpay for less-than-ideal diamonds. Eliminate this risk with a free consultation
                from a diamond expert.
              </div>
            </div>
            <div className={styles.listItem}>
              <Shape className={styles.listImage} />
              <div className={styles.listText}>
                The 4Cs aren’t “cut in stone” – the importance of each “C” varies significantly
                based on the shape of the diamond. Plus, other aspects like table and depth can
                matter just as much, if not more.
              </div>
            </div>
            <div className={styles.listItem}>
              <Price className={styles.listImage} />
              <div className={styles.listText}>
                All jewelry retailers work with the same few diamond mines and wholesalers. So why
                do you pay more for diamonds from certain retailers? They drastically mark-up
                prices. We don’t.
              </div>
            </div>
          </div>

          {sellableRecommendedExpert &&
            sellableRecommendedExpert.expert && (
              <div className={styles.footerContainer}>
                <ExpertChatButton expertId={sellableRecommendedExpert.expert.id}>
                  {(startExpertConsumerConversation, loading) => (
                    <>
                      <Button
                        className={styles.button}
                        size="large"
                        disabled={loading}
                        variant="primary"
                        onClick={() =>
                          startExpertConsumerConversation ? startExpertConsumerConversation() : null
                        }
                      >
                        <Experts />
                        Get expert assistance
                      </Button>

                      <Free className={styles.footerImage} />
                    </>
                  )}
                </ExpertChatButton>
              </div>
            )}
        </div>
        <Image src={Diamond} className={styles.rightImage} width={500} height={565} />
      </div>
    </PageContent>
  </div>
)

export default JewelryAssistance
